import React from 'react';
import { IDeleteDialog } from './interfaces';
import { useTranslation } from 'react-i18next';
import { ConfirmDialog } from '../ConfirmDialog';

export const DeleteDialog: React.FC<IDeleteDialog> = ({
  title,
  subTitle,
  children,
  show,
  confirmLabel,
  disabled = false,
  onClose,
  onConfirm,
}): JSX.Element => {
  const { t } = useTranslation();

  return (
    <ConfirmDialog
      show={show}
      title={title}
      subTitle={subTitle}
      disabled={disabled}
      confirmLabel={confirmLabel || t('buttons.delete')}
      confirmVariant="danger"
      onClose={onClose}
      onConfirm={onConfirm}
    >
      {children}
    </ConfirmDialog>
  );
};
